<template>
  <div
    class="event-item"
    ref="event-item"
    :style="{
      borderColor,
      backgroundColor,
      transform: `translate(${positionX}px, -50%)`,
      width: `${width}px`,
    }"
    @click="$emit('click')"
    @mouseenter="(e) => $emit('hover', e)"
    @mouseleave="(e) => $emit('hover', e)"
  >
    <div class="event-item__container">
      <div class="event-item__number">{{ title }}</div>
      <div class="event-item__content row-item" v-for="content in contents" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import eventItemColors from '../lib/constants/event-item-colors'

export default {
  inject: ['timeSelected'],
  props: {
    startTime: {
      type: String,
    },
    endTime: {
      type: String,
    },
    color: {
      type: String,
      default: 'blue',
    },
    title: {
      type: String,
      required: true,
    },
    contents: {
      type: Array,
      default: () => [],
    },
  },
  emit: ['click', 'hover'],
  data() {
    return {
      eventItemColors,
      itemWidthPerHour: 120,
    }
  },
  computed: {
    borderColor() {
      return this.eventItemColors[this.color].mainColor
    },
    backgroundColor() {
      return this.eventItemColors[this.color].backgroundColor
    },
    width() {
      const [hoursStart, minutesStart] = this.extractTime('start', this.startTime)
      const [hoursEnd, minutesEnd] = this.extractTime('end', this.endTime)
      const durationInHour = (hoursEnd * 60 + minutesEnd - (hoursStart * 60 + minutesStart)) / 60

      return durationInHour * this.itemWidthPerHour
    },
    positionX() {
      const [hoursStart, minutesStart] = this.extractTime('start', this.startTime)
      return (hoursStart + minutesStart / 60) * this.itemWidthPerHour
    },
  },
  mounted() {
    if (this.contents.length <= 1) return

    const eventItemParentRef = this.$refs['event-item'].parentElement

    // Adjust table cell height based on the contents length
    eventItemParentRef.style.height = `${80 + (this.contents.length - 1) * 20}px`
  },
  methods: {
    extractTime(type, time) {
      let parsedTime = moment(time)

      if (type == 'start') {
        if (parsedTime.isBefore(this.timeSelected, 'day')) {
          parsedTime.set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          })
        }
      } else if (type == 'end') {
        if (parsedTime.isAfter(this.timeSelected, 'day')) {
          parsedTime.set({
            hour: 23,
            minute: 59,
            second: 0,
            millisecond: 0,
          })
        }
      }

      return [parsedTime.hours(), parsedTime.minutes()]
    },
  },
}
</script>
<style scoped lang="scss">
.event-item {
  width: calc(300px);
  height: fit-content; // minus padding top and bottom of the table cell
  position: absolute;
  top: 50%;
  transform: translate(0px, -50%);
  border-left-width: 4px;
  border-left-style: solid;
  border-radius: 4px;
  padding: 2px 6px;
  cursor: pointer;
  z-index: 1;

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 4px;
  }

  &__number {
    font-weight: 600;
  }

  .row-item {
    display: flex;
    align-items: center;
    gap: 4px;

    :deep(.mc-icon::before) {
      font-size: 16px;
    }
  }

  & > div,
  .row-item :deep(div) {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
